import dayjs from 'dayjs';
import { flatFilters } from "@/components/asset_filter/filterQuery";

export const RELABEL_JOB_MAX_AGE_HOURS = 12;
export const RELABEL_JOB_DISPLAY_LIMIT = 8;

export function parseJobDescription(job) {
  if (!job || !job.description) {
    return {};
  }
  try {
    return JSON.parse(job.description);
  } catch (_) {
    return {};
  }
}

export function isRecentJob(job, maxAgeHours = RELABEL_JOB_MAX_AGE_HOURS) {
  if (!job || !job.created_at) {
    return false;
  }
  return dayjs().diff(dayjs(job.created_at), 'hour') < maxAgeHours;
}

export function isActiveJob(job) {
  return job && job.processed === 0 && !job.deleted_at;
}

export function isRunningJob(job) {
  return isActiveJob(job) && !!job.claimed_at && !job.on_hold;
}

export function isQueuedJob(job) {
  return isActiveJob(job) && (!job.claimed_at || job.on_hold);
}

export function filterRelabelInFilterJobs(jobs) {
  return (jobs || [])
    .filter((job) => job.task === 'relabel_in_filter')
    .filter((job) => isActiveJob(job))
    .filter((job) => isRecentJob(job));
}

export function formatFilterCriteria(filters, filterOptions) {
  const rows = flatFilters(filters);
  if (rows.length === 0) {
    return [];
  }

  const optionsByType = {};
  (filterOptions || []).forEach((option) => {
    optionsByType[option.type] = option;
  });

  return rows.map((filter) => {
    const option = optionsByType[filter.type];
    const label = option?.label || `Filter ${filter.type}`;
    const value = filter.value != null && filter.value !== '' ? String(filter.value) : '—';
    return { label, value };
  });
}

export function progressLabel(job) {
  const description = parseJobDescription(job);
  const relabeled = description.relabeled || 0;
  const total = description.total_estimate;
  if (total > 0) {
    return `${relabeled} / ${total}`;
  }
  if (relabeled > 0) {
    return String(relabeled);
  }
  return '';
}
